import * as React from "react";
import { CollapsableCard } from "../../../../../../../components/general/collapsable_card";
import { Box, Typography } from "@mui/material";

export default function DeviceValidationErrorCard({ deviceErrors, startCollapsed = false, ...props }) {
  deviceErrors = deviceErrors === undefined || !deviceErrors ? [] : deviceErrors;

  function GeneralValidationLine({ deviceError, index }) {
    const key = Object.keys(deviceError)[0]; // Gets the first (and only) key
    const errorList = deviceError[key];

    return (
      <Box key={index} sx={{ mt: 1 }}>
        <Typography variant="subtitle1">{key}</Typography>
        {errorList.map((err, idx) => (
          <Box
            key={idx}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 0.5,
              mt: "2px",
              pl: 4,
            }}
          >
            <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
              •
            </Typography>
            <Typography variant="body2">{err}</Typography>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <CollapsableCard
      startCollapsed={startCollapsed || (deviceErrors && deviceErrors.length === 0)}
      title={`Device validation errors (${deviceErrors ? deviceErrors.length : ""})`}
      width={"100%"}
      elevation={0}
      sx={props.sx}
    >
      {[...Array(deviceErrors.length)].map((_, idx) => (
        <GeneralValidationLine deviceError={deviceErrors[idx]} index={idx} />
      ))}
    </CollapsableCard>
  );
}
